import { html } from 'lit';

export const heroNetwork = html`
  <img
    class="hero-illus-img"
    src="/bko_reservation.jpeg"
    alt="Bamako, Mali and Michigan Reservation collaboration illustration"
    width="1024"
    height="1024"
    loading="eager"
    decoding="async"
  />
`;

export const teaserMali = html`
  <svg viewBox="0 0 300 160" aria-hidden="true">
    <rect width="300" height="160" fill="#F5F3EE"/>
    <rect x="40" y="60" width="220" height="70" rx="6" fill="#E4EBE2"/>
    <rect x="60" y="80" width="30" height="30" fill="#2F5233" opacity="0.7"/>
    <rect x="105" y="80" width="30" height="30" fill="#2F5233" opacity="0.5"/>
    <rect x="150" y="80" width="30" height="30" fill="#2F5233" opacity="0.7"/>
    <path d="M150 60 v-20 m-8 8 l8 -8 8 8" stroke="#2F5233" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const teaserJuvo = html`
  <svg viewBox="0 0 300 160" aria-hidden="true">
    <rect width="300" height="160" fill="#F5F3EE"/>
    <circle cx="150" cy="90" r="42" fill="#F4E4DE"/>
    <path d="M150 60 a30 30 0 1 1 -21 51" stroke="#B5533C" stroke-width="4" fill="none" stroke-linecap="round"/>
    <path d="M124 105 l6 12 12 -4" stroke="#B5533C" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const teaserDental = html`
  <svg viewBox="0 0 300 160" aria-hidden="true">
    <rect width="300" height="160" fill="#F5F3EE"/>
    <rect x="105" y="55" width="90" height="70" rx="10" fill="#E1EBF0"/>
    <circle cx="150" cy="90" r="14" fill="none" stroke="#3E6E8E" stroke-width="3"/>
    <path d="M150 76 v28 M136 90 h28" stroke="#3E6E8E" stroke-width="3" stroke-linecap="round"/>
    <circle cx="120" cy="62" r="4" fill="#3E6E8E"/>
    <circle cx="180" cy="118" r="4" fill="#3E6E8E"/>
  </svg>
`;

export const entryMali = html`
  <svg viewBox="0 0 260 220" aria-hidden="true">
    <rect width="260" height="220" fill="#F5F3EE"/>
    <rect x="50" y="70" width="160" height="110" rx="8" fill="#E4EBE2"/>
    <rect x="70" y="95" width="34" height="34" fill="#2F5233" opacity="0.75"/>
    <rect x="115" y="95" width="34" height="34" fill="#2F5233" opacity="0.5"/>
    <rect x="160" y="95" width="34" height="34" fill="#2F5233" opacity="0.75"/>
    <path d="M130 70 v-24 m-9 9 l9 -9 9 9" stroke="#2F5233" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <circle cx="130" cy="160" r="12" fill="#fff" stroke="#2F5233" stroke-width="2"/>
    <path d="M124 160 h12 M130 154 v12" stroke="#2F5233" stroke-width="2"/>
  </svg>
`;

export const entryJuvo = html`
  <svg viewBox="0 0 260 220" aria-hidden="true">
    <rect width="260" height="220" fill="#F5F3EE"/>
    <circle cx="130" cy="115" r="55" fill="#F4E4DE"/>
    <path d="M130 78 a37 37 0 1 1 -26 63" stroke="#B5533C" stroke-width="4" fill="none" stroke-linecap="round"/>
    <path d="M97 133 l7 15 15 -5" stroke="#B5533C" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    <rect x="110" y="100" width="40" height="28" rx="4" fill="#fff" stroke="#B5533C" stroke-width="2"/>
  </svg>
`;

export const entryDental = html`
  <svg viewBox="0 0 260 220" aria-hidden="true">
    <rect width="260" height="220" fill="#F5F3EE"/>
    <rect x="75" y="55" width="110" height="90" rx="12" fill="#E1EBF0"/>
    <circle cx="130" cy="100" r="18" fill="none" stroke="#3E6E8E" stroke-width="3"/>
    <path d="M130 82 v36 M112 100 h36" stroke="#3E6E8E" stroke-width="3" stroke-linecap="round"/>
    <circle cx="95" cy="65" r="5" fill="#3E6E8E"/>
    <circle cx="165" cy="130" r="5" fill="#3E6E8E"/>
    <rect x="105" y="155" width="50" height="12" rx="6" fill="#3E6E8E" opacity="0.5"/>
  </svg>
`;

export const iconClinic = html`
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M3 21h18M5 21V9l7-5 7 5v12M9 21v-6h6v6" stroke="#2F5233" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const iconPeople = html`
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="9" cy="8" r="3" stroke="#B5533C" stroke-width="2"/>
    <path d="M2 21v-2a5 5 0 0 1 5-5h4a5 5 0 0 1 5 5v2M17 8a3 3 0 1 0 0-6M20 21v-2a4 4 0 0 0-2.5-3.7" stroke="#B5533C" stroke-width="2" stroke-linecap="round"/>
  </svg>
`;

export const iconDevices = html`
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M17 2.1l4 4-4 4M21 6H7a4 4 0 0 0-4 4v1M7 21.9l-4-4 4-4M3 18h14a4 4 0 0 0 4-4v-1" stroke="#3E6E8E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const iconGlobe = html`
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zM2 12h20M12 2a15 15 0 0 1 4 10 15 15 0 0 1-4 10 15 15 0 0 1-4-10 15 15 0 0 1 4-10z" stroke="#C98A2E" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const iconHeart = html`
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 21s-7-4.6-9.5-9C1 8.6 3 5 6.5 5c2 0 3.5 1.2 4 2.3.5-1.1 2-2.3 4-2.3C18 5 20 8.6 18.5 12c-2.5 4.4-6.5 9-6.5 9z" stroke="#2F5233" stroke-width="1.8" stroke-linejoin="round"/>
  </svg>
`;

export const iconSun = html`
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M12 2v4M12 18v4M4.9 4.9l2.8 2.8M16.3 16.3l2.8 2.8M2 12h4M18 12h4M4.9 19.1l2.8-2.8M16.3 7.7l2.8-2.8" stroke="#B5533C" stroke-width="1.8" stroke-linecap="round"/>
  </svg>
`;

export const iconVolunteer = html`
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM3 21v-1a5 5 0 0 1 5-5h2a5 5 0 0 1 5 5v1M17 8l3 3 5-5" stroke="#3E6E8E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
`;

export const iconBriefcase = html`
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="7" width="18" height="12" rx="2" stroke="#C98A2E" stroke-width="1.8"/>
    <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="#C98A2E" stroke-width="1.8"/>
  </svg>
`;
